import { StyleSheet } from '@react-pdf/renderer';

const colors = {
  mainGreen: '#2EAF98',
  mainRed: '#D32F2F',
  mainOrange: '#EF6C00',
  redTint: 'rgba(211, 47, 47, 0.04)',
  dividerColor: '#C4C4C4',
  grey: 'rgba(0, 0, 0, 0.6)',
  borderColor: '#9e9e9e',
};

const styles = StyleSheet.create({
  // Page level styles
  page: {
    padding: 150,
  },
  pageTitle: {
    color: colors.mainGreen,
    fontFamily: 'Work Sans',
    fontSize: 28,
    fontWeight: 400,
    marginBottom: 16,
    textAlign: 'left',
  },
  pageSubTitle: {
    color: colors.mainGreen,
    fontFamily: 'Work Sans',
    fontSize: 24,
    fontWeight: 400,
    marginBottom: 16,
    textAlign: 'left',
  },
  pageNumber: {
    bottom: '86px',
    fontFamily: 'Lato',
    fontSize: 16,
    color: colors.grey,
    position: 'absolute',
    right: '70px',
  },

  // Text styles
  boxTitle: {
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
  boxSubTitle: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: '14',
  },
  groupTitle: {
    fontSize: 18,
    marginVertical: 16,
    color: colors.mainGreen,
    fontWeight: 400,
    fontFamily: 'Work Sans',
  },
  subGroupTitle: {
    fontSize: 14,
    fontWeight: 400,
    paddingVertical: 15,
    color: colors.mainGreen,
    fontFamily: 'Lato',
    paddingLeft: 10,
    borderBottom: 1,
    borderColor: colors.borderColor,
  },
  controlText: {
    color: colors.grey,
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 300,
    paddingLeft: 20,
    width: '295px',
  },
  rowText: {
    color: colors.grey,
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 300,
    paddingLeft: 10,
    width: '165px',
  },
  subheaderText: {
    fontFamily: 'Work Sans',
    color: colors.mainGreen,
    fontSize: 16,
    fontWeight: 'bold',
    width: 240,
  },
  unfinishedControlTitle: {
    fontFamily: 'Work Sans',
    fontSize: 18,
    fontWeight: 400,
    color: colors.mainOrange,
    marginBottom: '16px',
  },

  // Box and container styles
  longTextBox: {
    width: '940px',
    marginBottom: '20px',
  },
  infoBox: {
    width: '500px',
  },
  infoBoxRow: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  quickTagContainer: {
    maxWidth: '940px',
  },
  controlTextContainer: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 15,
    borderBottom: 1,
    borderColor: colors.borderColor,
  },
  controlHeaderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 20,
    paddingVertical: 15,
    borderBottom: 1,
    borderColor: colors.borderColor,
  },
  groupControls: {
    marginBottom: 16,
  },
  unfinshedControlContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    paddingVertical: 15,
    borderBottom: 1,
    borderColor: colors.borderColor,
  },

  // Column styles
  wideColumn: {
    width: '355px',
  },
  mediumColumn: {
    alignItems: 'flex-start',
    width: '225px',
  },
  smallColumn: {
    width: '135px',
  },
  // Divider styles
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: '#C4C4C4',
  },

  // Color styles
  mainGreen: {
    color: colors.mainGreen,
  },
  mainRed: {
    color: colors.mainRed,
  },
  mainOrange: {
    color: colors.mainOrange,
  },
  notApplicableBackground: {
    backgroundColor: colors.redTint,
  },
});

export default styles;
